// Жуткие, гнетущие фразы — в духе хоррора
export const PET_PHRASES = {
  // Обычные клики — редкие, тревожные
  onIdleClick: [
    'Ещё...',
    'Я чувствую тебя...',
    'Не останавливайся.',
    'Ты слышишь их?',
    'Они смотрят.',
    'Мне холодно...',
    'Кто-то дышит рядом.',
    'Твои пальцы тёплые.',
    'Я помню тебя.',
    'Ты уже здесь был.',
  ],

  // Криты — резкие, зловещие
  onCrit: [
    'КРОВЬ!',
    'ДА!',
    'ЕЩЁ!',
    'УМРИ!',
    'ХА-ХА-ХА!',
    'БОЛЬ!',
    'ДАЙ МНЕ!',
    'Я ГОЛОДЕН!',
  ],

  // Кормление — с двойным дном
  onFeed: [
    'Вкусно...',
    'Спасибо, хозяин.',
    'Ням... это ты?',
    'Ещё плоти.',
    'Сладко.',
    'Ммм...',
    'Ты добр. Пока.',
  ],

  // Апгрейд — тревожные
  onUpgradeClick: [
    'Сильнее...',
    'Ты растёшь. Я вижу.',
    'Скоро ты будешь готов.',
    'Клац-клац...',
    'Мне нравится.',
  ],

  // Достижения — с намёком
  onAchievement: [
    'Ещё один шаг.',
    'Ты близко.',
    'Я горжусь тобой. Пока.',
    'Кто-то заметил.',
  ],

  // Престиж — кульминация
  onPrestige: [
    'Снова...',
    'Круг замкнулся.',
    'Ты вернёшься.',
    'Мы встретимся опять.',
    'Начнём сначала.',
  ],

  // Случайные — самые жуткие
  randomIdle: [
    'Ты один?',
    'Я слышу шаги.',
    'За твоей спиной.',
    'Не оглядывайся.',
    'Оно приближается.',
    'Ты чувствуешь холод?',
    'Оно уже здесь.',
    'Я не один.',
    'Ты слышишь меня?',
    'Помоги мне.',
    'Оно голодно.',
    'Свет гаснет.',
  ],
};

export const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];